import { StorageTester } from '../components/StorageTester'

export default function StorageTestPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Supabase Storage Test
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Use this page to test all storage operations including upload, download, 
            file listing, URL generation, and more. Make sure you have configured 
            your environment variables first.
          </p>
        </div>
        
        <StorageTester />
        
        <div className="mt-12 text-center">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 max-w-2xl mx-auto">
            <h3 className="text-lg font-semibold text-blue-900 mb-2">
              Need Help?
            </h3>
            <p className="text-blue-700 text-sm mb-4">
              Check the documentation for detailed configuration instructions 
              and troubleshooting tips.
            </p>
            <div className="text-xs text-blue-600">
              <p>• Verify your .env file has all required variables</p>
              <p>• Check that your Supabase project is active</p>
              <p>• Ensure storage buckets are properly configured</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
